import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/query/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchProducersOrganizations(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/query/fetch_producers_organizations/${agro_exporter_process_id}`
    );
  },
  fetchCropFields(agro_exporter_process_id, producer_id, organization_id) {
    return RequesterV1.get(
      `agro_exporter/production/uniq_final_packing_list/query/fetch_crop_fields/${agro_exporter_process_id}?producer_id=${producer_id}&organization_id=${organization_id}`
    );
  }
};
